import { h, JSX } from 'preact';

import cx from 'clsx';

import styles from './Button.module.scss';

export interface IButtonProps {
	className?: string;
	children?: h.JSX.Element | null | string;
	disabled?: boolean;
	variant?: 'primary' | 'secondary' | 'default' | 'link' | 'danger';
	onClick?: (event: JSX.TargetedMouseEvent<HTMLButtonElement>) => void;
	id?: string;
	onMouseEnter?: () => void;
	onMouseLeave?: () => void;
	onBlur?: () => void;
}

const Button = ({
	children,
	className,
	disabled = false,
	onClick,
	variant = 'default',
	...props
}: IButtonProps) => {
	const handleClick = (event: JSX.TargetedMouseEvent<HTMLButtonElement>) => {
		if (!disabled && onClick) {
			onClick(event);
		}
	};
	return (
		<button
			className={cx(
				'border-radius2',
				{ [styles.disabled]: disabled, pointer: !disabled },
				styles.button,
				{
					[styles.ripple]: variant === 'primary' || variant === 'secondary',
				},
				'border-radius2 pointer',
				{
					'bg-primary color-primaryLabel p3 h5 bold': variant === 'primary',
					'bg-primaryLight color-primary p3 h5 bold': variant === 'secondary',
					'bg-white color-labelDark h6 p0 lighter': variant === 'link',
					'bg-error color-error h5 bold': variant === 'danger',
					'bg-white color-labelDark h5 bold': variant === 'default',
				},
				className,
			)}
			onClick={handleClick}
			disabled={disabled}
			{...props}
		>
			{children}
		</button>
	);
};

export default Button;
